"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMuiSelect = exports.Select = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _styles = require("@mui/material/styles");
var _Icon = require("../Basics/Icons/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StyledMuiSelect = (0, _styles.styled)(_Select.default)`
    color: var(--btn-text-color);
    background-color: var(--btn-bg-color);

    position: relative;
    background: transparent;
    transition: all 0.4s ease;
    vertical-align: top;

    line-height: 30px;
    font-size: 14px;
    
    border: 1px solid var(--btn-border-color);
    border-radius: 2px;

    /* Vendor */
    .MuiSelect-select {
        padding: 0;
        padding-left: 16px;
        padding-right: 32px;
    }

    .MuiPaper-root {
        margin-top: 1px;
        background: var(--bg-color);
    }

    /* VCS */
    #vcs-dropdown__icon {
        transform: rotate(-90deg);
        position: absolute;
        right: 8px;
        top: 8px;
        /* Otherwise the icon is not clickable */
        pointer-events: none; 
    }

    fieldset, legend {
        border: 0;
    }

    ${props => !props.disabled && (0, _styles.css)`
        &.hover,
        &:hover {
            filter: brightness(90%);
        }

        &.active,
        &:active {
            filter: brightness(80%);
        }
    `}
`;
exports.StyledMuiSelect = StyledMuiSelect;
StyledMuiSelect.propTypes = _Select.default.propTypes;

/*
    The Menu is rendered outside the wrapper of the component, because it's modal
    So, in the DOM, it might stay outside the body. The themes are applied as a CSS style
    to the body, so the Menu list doesn't get the proper colors.
    Manually add the theme class to the Menu
*/

const ThemedSelect = props => {
  return /*#__PURE__*/React.createElement(StyledMuiSelect, _extends({
    MenuProps: {
      className: props.getThemeClass(),
      sx: {
        backgroundColor: 'transparent',
        '& .MuiMenu-paper': {
          color: 'var(--btn-text-color)',
          backgroundColor: 'var(--btn-bg-color)'
        }
      }
    }
  }, props));
};
exports.Select = ThemedSelect;
ThemedSelect.propTypes = _objectSpread(_objectSpread({}, _Select.default.propTypes), {}, {
  getThemeClass: _propTypes.default.func
});
ThemedSelect.defaultProps = {
  IconComponent: () => /*#__PURE__*/React.createElement(_Icon.Icon, {
    icon: "left-arrow",
    size: "sm",
    id: "vcs-dropdown__icon"
  }),
  getThemeClass: () => Array.from(document.body.classList).find(c => c.startsWith('vcs-theme'))
};